<div class="checkout-group" [formGroup]="mode">
  <div class="checkout-group-title">
    {{ 'checkout.group.deliveryMode.title' | cxTranslate }}
  </div>
  <div class="checkout-group-body">
    @if ((supportedDeliveryModes$ | async)?.length) {
    <mat-form-field appearance="outline" class="mat-primary mat-form-field">
      <mat-label>{{ 'checkout.group.deliveryMode.title' | cxTranslate }}</mat-label>
      <mat-select
        appearance="outline"
        formControlName="deliveryModeId"
        (selectionChange)="changeMode($event.value)"
        disableOptionCentering
        panelClass="checkout-select"
      >
        @for (mode of supportedDeliveryModes$ | async; track mode) {
        <mat-option id="deliveryMode-{{ mode.code }}" [value]="mode.code">
          {{ mode.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
  </div>
</div>
